<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl6 lg6 xs6>
                        <v-text-field v-model="filters.bodyType" :label="filtersLabel.bodyType" :error-messages="errors.collect('bodyType')" data-vv-name="bodyType" :data-vv-as="filtersLabel.bodyType" v-validate="'param|max:20'"></v-text-field>
                      </v-flex>
                      <v-flex xl6 lg6 xs6>
                        <v-text-field v-model="filters.description" :label="filtersLabel.description" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="filtersLabel.description" v-validate="'param|max:40'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">Body Type Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="bodyType" :loading="loading" :no-data-text="noDataText">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.bodyType }}</td>
              <td class="text-xs-left">{{ props.item.description }}</td>
              <td class="text-xs-right" v-if="checkAccess(['vehicleReview'])">
                <table-action :rowData="props" review @review="doReview(props.item.bodyType)" remove @remove="doPromptRemove(props.item)"></table-action>
              </td>
            </template>
          </v-data-table>
          <v-btn color="primary" dark class="mb-2" @click="doNew()">
            New Body Type
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card>
        <v-dialog v-model="bodyTypeDialog" width="800px" lazy v-if="checkAccess(['vehicleReview'])" persistent >
          <body-type-dialog :bodyTypeForm="bodyTypeForm" @close="doClose" :newBodyType="newBodyType"></body-type-dialog>
        </v-dialog>
        <confirm v-model="promptRemove" @ok="doRemove">
          Are you sure that you want to delete the selected Vehicle Body Type? ({{deleteVehBodyType}})
        </confirm>
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import BodyTypeDialog from './BodyTypeDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Body Type Code', align: 'left', value: 'bodyType' },
        { text: 'Body Type Description', align: 'left', value: 'description' }
      ],
      totalItems: 0,
      filters: {
        bodyType: null,
        description: null
      },
      filtersLabel: {
        bodyType: 'Body Type Code',
        description: 'Description'
      },
      bodyTypeForm: {
        bodyType: undefined,
        bodyTypeDesc: undefined
      },
      bodyTypeDialog: undefined,
      newBodyType: undefined,
      loading: false,
      promptRemove: false,
      selectedVehBodyType: undefined,
      deleteVehBodyType: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.vehicle.menu.getVehBodyTypes
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((vehBodyType) => {
                const convertBodyType = {
                  bodyType: vehBodyType.bodyType,
                  description: vehBodyType.description
                }
                this.items.push(convertBodyType)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.bodyType = null
      this.filters.description = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doClose() {
      this.bodyTypeDialog = false
      this.newBodyType = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.bodyTypeDialog = true
      this.newBodyType = true
    },
    async doReview(bodyType) {
      const apiURI = this.$store.state.vehicle.menu.getVehBodyType
      const expand = {
        bodyType: bodyType
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.bodyTypeForm.bodyType = data.bodyType.bodyType
          this.bodyTypeForm.bodyTypeDesc = data.bodyType.description
        }
        this.bodyTypeDialog = true
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVehBodyType = data
        this.deleteVehBodyType = data.bodyType + ' - ' + data.description
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.vehicle.menu.deleteVehBodyType
      if (apiURI) {
        this.loading = true
        const expand = {
          bodyType: this.selectedVehBodyType.bodyType
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  created() {
    if (this.checkAccess(['vehicleReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    BodyTypeDialog: BodyTypeDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
